/*global Daon*/
/*eslint no-undef: "error"*/
import { store } from "../store";

const actionPrefix = "LIVENESS_TEST_";

export const CREATE_INSTANCE = actionPrefix + "CREATE_INSTANCE";
export const SET_TEST_DATA = actionPrefix + "SET_TEST_DATA";
export const SET_VIDEO_ID = actionPrefix + "SET_VIDEO_ID";
export const RETRY = actionPrefix + "RETRY";
export const FIRST_TIME_INIT = actionPrefix + "FIRST_TIME_INIT";
export const ERROR_MESSAGE = actionPrefix + "ERROR_MESSAGE";

export function createInstance() {
  return {
    type: CREATE_INSTANCE,
    payload: new Daon.CLRCapture(true)
  }
}

export function firstTimeInit() {
  return {
    type: FIRST_TIME_INIT
  }
}

export function setTestData(payload) {
  return {
    type: SET_TEST_DATA,
    payload
  }
}


export function setVideoId(payload) {
  return {
    type: SET_VIDEO_ID,
    payload
  }
}


export function retry() {
  const { livenessTest } = store.getState();

  return {
    type: RETRY,
    payload: livenessTest && livenessTest.livenessTestData && livenessTest.livenessTestData.items[0].type
  }
}

export function errorMessage(payload) {
  return {
    type: ERROR_MESSAGE,
    payload
  }
}